import React from 'react'
import "../components/Hero.css"

function Hero() {
  return (
    <div className='hero'>
      <h1>making your ideas become reality</h1>
      <p>At Bell®, we understand that in the 
        fast-paced digital landscape, having 
        robust and innovative software is the 
        key to staying ahead. We are a dynamic 
        team of skilled professionals dedicated 
        to building tailored software solutions 
        that empower businesses to thrive.</p>
    </div>
  )
}

export default Hero
